<div class="modal" id="{{mId}}" tabindex="-1" role="dialog" aria-labelledby="dialogAlertModalLabel" aria-hidden="true"  data-keyboard="false" data-backdrop="static">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<ng-container *ngIf="mDialogInstance != null && mDialogInstance.dialog != null">

				<!-- Dialog Header -->
				<div class="modal-header modal-header-danger">
					<span class="glyphicon glyphicon-alert"></span>
						{{mDialogInstance.creationDate | date:"MMM d, y h:mm:ss a" | uppercase}} - {{ mDialogInstance.dialog.type | uppercase}}
					<div class="pull-right">
						<span (click)="hide()" style="cursor: pointer"><i class="fa fa-times" aria-hidden="true"></i></span>
					</div>
				</div>

				<!-- Dialog Body -->
				<div class="modal-body-danger">
					<div class="container-fluid bd-example-row" style="margin-bottom: 0px;">

						<!-- Message (Top Level) -->
						<div class="row" style="color: #000000">
							<p align="center" style="font-size: 24px">
								{{mDialogInstance.message == null? "" : mDialogInstance.message}}
							</p>
						</div>
            <!-- Main Body -->
						<div id="dialogBodyPane" class="row" style="height:100%; display: flex; align-content: stretch" [class.alert-disabled]="mDialogInstance.status == 'CLOSED'">

							<!-- Left Hand Side (Alert Info / Checklist / Comments) -->
							<div class="col-sm-7" style="height: 450px; overflow-y: auto">

								<!-- Alert Info Pane -->
								<!-- Picture -->
								<div *ngIf="mDialogInstance.source != null" class="col-sm-4" style="padding: 5px; margin: 0;">
									<div class="well-danger">
										<img [src]="getPathForSourceImage()" class="img-responsive" />
									</div>
								</div>
								<!-- Info -->
								<div [class.col-sm-8]="mDialogInstance.user != null" [class.col-sm-12]="mDialogInstance.user == null" style="padding: 5px; margin: 0;">
									<div class="list-group">
										<a class="list-group-item-alert">
											<p class="list-group-item-text">
												<strong><i class="fa fa-user"></i> ALERT FROM:</strong>
												{{mDialogInstance.source == null ? "System" : mDialogInstance.source.name}}
											</p>
										</a>
										<a class="list-group-item-alert">
											<p class="list-group-item-text">
												<strong><i class="fa fa-exclamation"></i> ALERT TYPE:</strong>
												{{mDialogInstance.dialog.type}}
											</p>
										</a>
										<a class="list-group-item-alert">
											<p class="list-group-item-text">
												<strong><i class="fa fa-calendar"></i> DATE & TIME:</strong>
												{{mDialogInstance.creationDate | date:"MMM d, y h:mm a"}}
											</p>
										</a>
										<a class="list-group-item-alert">
											<p class="list-group-item-text">
												<strong><i class="fa fa-map"></i> LOCATION:</strong>
												{{mDialogInstance.locationInstance == null? "" : mDialogInstance.locationInstance.name}}
											</p>
										</a>
										<a class="list-group-item-alert">
											<p class="list-group-item-text">
												<strong><i class="fa fa-map-marker"></i> ZONE:</strong>
												{{mDialogInstance.zoneInstance == null? "" : mDialogInstance.zoneInstance.name}}
											</p>
										</a>
									</div>
								</div>


								<div class="col-sm-12" style="padding: 5px;margin: 0">

									<!-- Checklist Header -->
									<div class="tab" *ngIf="mDialogInstance.dialog.items != null && mDialogInstance.dialog.items.length > 0">
										<div class="pull-right" style="margin: 10px">
										<a style="color: #bc0000" data-toggle="tooltip" title="Complete as many tasks as needed on this CHECKLIST. The list of AUTOMATIC REACTIONS are things that have been done automatically.">
											<i class="fa fa-info-circle" aria-hidden="true"></i>
										</a>
										</div>
										<button class="tablinks">
											<i class="fa fa-check" aria-hidden="true"></i>
											{{mDialogInstance.dialog.itemsHeader == null? "" : mDialogInstance.dialog.itemsHeader}}
										</button>
									</div>

									<!-- Checklist Items -->
									<div id="CHECKLIST" class="tabcontent"  *ngIf="mDialogInstance.dialog.items != null && mDialogInstance.dialog.items.length > 0" style="max-height: 200px; overflow-y: auto; overflow-x: hidden;">
										<ul class="alert" id="myUL">
											<li *ngFor="let datum of mDialogInstance.data" [class.checked]="datum.checked" (click)="datum.checked = !datum.checked">
												{{datum.dialogItem.label}}
											</li>
										</ul>
									</div>

									<!-- Comments -->
									<div id="dialogTextPanel" class="panel panel-danger" *ngIf="mDialogInstance.dialog.showComment">
										<div class="panel-heading">
											<h1 id="dialogTextTitle" class="panel-title" style="font-size: 18px;  padding: 8px;">{{mDialogInstance.dialog.messageHeader == null? "" : mDialogInstance.dialog.messageHeader}}</h1>
										</div>
										<div class="panel-body" style="background-color:#fafafa; margin: 0; padding: 0; max-height: 200px">
											<textarea class="form-control" rows="5" style="color: #000000; background-color: #d9d9d9" [(ngModel)]="mDialogInstance.comment"></textarea>
										</div>
									</div>
								</div>
							</div>
							<!-- Right Hand Side / Map -->
							<div class="col-sm-5" style="" id="mapDiv" *ngIf="mDialogInstance.dialog.showMap">
								<app-map #alertMapComponent [mapInModal]="true" [location]="mDialogInstance.locationInstance" [eventPoint]="mDialogInstance.point"
                         [overrideDefaults]="overrideDefaults"
                         [displayAssets]="displayAssets" [displayPeople]="displayPeople" [showBreadcrumbs]="showBreadcrumbs"
                         [displayZones]="displayZones" [showZoneNames]="showZoneNames"
                         [displaySublocations]="displaySublocations" [showSublocationNames]="showSublocationNames"
                         [displayPerimeters]="displayPerimeters" [displayMenu]="true"
                         [zoomToZone]="zoomToZone" [mapVIPs]="mapVIPs"
                ></app-map>
							</div>
            </div>
          </div>
				</div>

				<!-- Footer / Buttons -->
				<div *ngIf="mDialogInstance.dialog.buttons != null"class="modal-footer-danger" style="height: 70px" [class.alert-disabled]="mDialogInstance.status == 'CLOSED'">
					<div style="float: right; margin: 5px" *ngFor="let button of mDialogInstance.dialog.buttons">
						<button type="button" [ngClass]="getClassForButton(button)" (click)="onButtonClick(button)">
							{{button.label}}
						</button>
					</div>
				</div>
			</ng-container>
		</div>
	</div>
</div>
